// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1O77-","large":"styles_large__l-jOW"};